export enum InvoiceIssueTypeInternational {
    BILLING_PERIOD = 'Billing Period',
    DUPLICATE_INVOICE = 'Duplicate Invoice',
    INCORRECT_ACCOUNT = 'Incorrect Account',
    INCORRECT_PRICE = 'Incorrect Price',
    ORDER_QUANTITY = 'Order Quantity',
    PAYMENT_TERMS = 'Payment Terms',
    OTHER = 'Other'
}
